module.exports = __webpack_public_path__ + "img/39_7.a4ca34f4.png";